// Generated by CoffeeScript 1.11.1
(function() {
  var BlendInteriorElements, LayerInfo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  module.exports = BlendInteriorElements = (function(superClass) {
    extend(BlendInteriorElements, superClass);

    function BlendInteriorElements() {
      return BlendInteriorElements.__super__.constructor.apply(this, arguments);
    }

    BlendInteriorElements.shouldParse = function(key) {
      return key === 'infx';
    };

    BlendInteriorElements.prototype.parse = function() {
      this.enabled = this.file.readBoolean();
      return this.file.seek(3, true);
    };

    return BlendInteriorElements;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/blend_interior_elements.js
// module id = 57
// module chunks = 0